// import '@/assets/js/common/kksa_kuaikanapp.js' // 上报到快看线上
import '@/assets/js/common/kksa_default.js' // 上报到快看默认
import { getParam } from "./params";
import { state } from "../store/state";
const { log } = console;

//通用属性
let common_property = {
    PayActivityName: "联合会员买1赠N活动",
    TriggerPage: getParam["origin"] ? getParam["origin"] : "HomePage",
    H5Page: window.location.href,
    cps: getParam["cps"] ? getParam["cps"] : "",
}
//上报
function doTrack(ButtonName, param, cantrack) {
    if (!cantrack) {
        console.log("未获取到uid或设备Id，不进行埋点上报")
        return false;
    }
    let event_name = ButtonName == "load" ? "PayActivityPV" : "PayActivityBtnClk";
    console.log(event_name, param);
    kksa.track(event_name, param);
}

export default function (opt) {
    log("埋点参数", opt);
    let PayActivitySubName = state.subname, cantrack = state.can_track, MembershipClassify = state.membership_classify;

    let { name: ButtonName = "", IsOrderSuccess = 0, MembershipPrdName = "3个月", CurrentPrice = 50, IsOpenSuccess = 0, TopicName = "" } = opt;

    let baseClick = {
        ...common_property,
        ButtonName,
        MembershipClassify: MembershipClassify,
        PayActivitySubName
    };

    let param = {};

    switch (opt.name) {
        case "load":
            param = { ...common_property, MembershipClassify, PayActivitySubName };
            break;
        case "预约提醒":
        case "预约提醒吸底":
        case "页面分享":
        case "活动规则":
        case "快看漫画特权":
        case "其他应用特权":
        case "领取权益":
        case "保存到相册":
        case "图片分享":
            param = { ...baseClick }
            break;
        case "点击封面":
            param = { ...baseClick, TopicName }
            break;
        case "立即预约":
            param = { ...baseClick, IsOrderSuccess }
            break;
        case "限量抢购":
        case "限量抢购吸底":
        case "立即抢购":
            param = { ...baseClick, MembershipPrdName, CurrentPrice, IsOpenSuccess }
            break;
        default:
            break;
    }
    doTrack(ButtonName, param, cantrack);
}



// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/js/track.js